import(/* webpackMode: "eager" */ "/app/landing/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/landing/src/components/common/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/landing/src/components/SupportChatWidgetGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/app/landing/src/lib/i18n-context.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/leaflet/dist/leaflet.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
